import { PathPattern, InheritedPathPattern } from 'path-pattern';

export const basePath = new PathPattern('/');
export const discoverPath = new InheritedPathPattern(basePath, '/');
export const explainPath = new InheritedPathPattern(basePath, '/fonctionnement');
export const aboutPath = new InheritedPathPattern(basePath, '/a-propos');

export const proPath = new InheritedPathPattern(basePath, '/professional');



// WEBPACK FOOTER //
// src/app/src/config/paths.ts